/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const DashboardDetailled = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    <rect width="19" height="19" fill="none" />
    <g id="Groupe_12" data-name="Groupe 12" transform="translate(1.156 1.156)">
      <rect width="1" height="3" transform="translate(12.844 10.844)" fill="currentColor" />
      <rect width="1" height="6" transform="translate(10.844 7.844)" fill="currentColor" />
      <path
        d="M8.891,21.781A2.894,2.894,0,0,1,6,18.891H7.156a1.734,1.734,0,1,0,1.734-1.734V16a2.891,2.891,0,0,1,0,5.781Z"
        transform="translate(-3.688 -7.906)"
        fill="currentColor"
      />
      <path
        d="M17.031,2H3.156A1.157,1.157,0,0,0,2,3.156V17.031a1.158,1.158,0,0,0,1.156,1.156H17.031a1.158,1.158,0,0,0,1.156-1.156V3.156A1.158,1.158,0,0,0,17.031,2Zm0,5.2H8.938V3.156h8.094ZM7.781,3.156V7.2H3.156V3.156ZM3.156,17.031V8.359H17.032v8.672Z"
        transform="translate(-2 -2)"
        fill="currentColor"
      />
    </g>
  </svg>
);

export { DashboardDetailled };
